import {
    getData,
} from './Services'

import { getOrderHisDetailPanel } from './OrderHisDetailServices'
export const getOrderHisLista = async () => {
  const res = await getData('/ordercache');
  return res
}


export const getOrderHisById = async (id) => {
  const res = await getData(`/orderhis/${id}`)
  return res
}

export const getOrderHisPanel = async (searchCli, searchSel, dateFrom, dateUntil, page, perPage) => {
  let queryParams = [];

  if (searchCli) queryParams.push(`cli_id=${encodeURIComponent(searchCli)}`);
  if (searchSel) queryParams.push(`sel_id=${encodeURIComponent(searchSel)}`);
  if (dateFrom) queryParams.push(`fechaDesde=${encodeURIComponent(dateFrom)}`);
  if (dateUntil) queryParams.push(`fechaHasta=${encodeURIComponent(dateUntil)}`);
  if (page) queryParams.push(`page=${encodeURIComponent(page)}`);
  if (perPage) queryParams.push(`perPage=${encodeURIComponent(perPage)}`);

  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

  try {
    const res = await getData("/orderhis/busquedaOrderHis_filtros", queryString);
    return res;
  } catch (err) {
    console.error("Error al obtener historial de pedidos con filtros", err);
    return { pedidos: [], pagination: { totalItems: 0 } };
  }
};

 